import formatarNumero from './formatarNumero'
import clipText from "./clipText";

export default {
    install(Vue) {
        Vue.filter('formatarNumero', formatarNumero)
        Vue.filter('clipTextFrom', clipText)
    }
}